import React, {Component} from 'react'
import {CSSTransition} from 'react-transition-group'
import Search from './Search'

import style from './dropdown.sass'

class Dropdown extends Component {
  state = {
    active: null
  }
  componentDidMount() {
    document.addEventListener('keydown', this.handleKeypress)
  }
  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeypress)
  }

  handleKeypress = (e) => {
    const {items} = this.props
    if (!Array.isArray(items)) {
      return
    }
    if (e.keyCode === 38 || e.keyCode === 40) {
      this.setActiveItem(e.keyCode)
    }
  }
  setActiveItem(code) {
    const {items} = this.props
    const index = items.findIndex(item => item.value === this.state.active)
    if (!this.state.active || index === -1) {
      this.setState({active: items[0].value})
    } else {
      if (code === 38) {
        if (index > 0) {
          this.setState({active: items[index-1].value})
        } else {
          this.setState({active: items[items.length-1].value})
        }
      }
      if (code === 40) {
        if (index < items.length - 1) {
          this.setState({active: items[index+1].value})
        } else {
          this.setState({active: items[0].value})
        }
      }
    }
    this.scrollToItem()
  }
  scrollToItem() {
    const dropdown = this.wrapper.querySelector('ul')
    const activeItem = this.wrapper.querySelector(`[value="${this.state.active}"]`)
    const dRect = dropdown.getBoundingClientRect()
    const aRect = activeItem.getBoundingClientRect()
    if (aRect.top < dRect.top) {
      activeItem.scrollIntoView()
    }
    if (aRect.bottom > dRect.bottom) {
      activeItem.scrollIntoView(false)
    }
  }
  handleMouseEnter = (e) => {
    const active = e.target.value
    this.setState({active})
  }
  handleMouseLeave = (e) => {
    if (this.state.active === e.target.value) {
      this.setState({active: null})
    }
  }

  render() {
    const {active} = this.state
    const {visible, onSelect, searchProps} = this.props
    let {items, selected, loadingItems} = this.props

    if (!Array.isArray(items)) {
      items = []
    }
    if (!Array.isArray(selected)) {
      selected = selected ? [selected] : []
    }
    if (!Array.isArray(loadingItems)) {
      loadingItems = loadingItems ? [loadingItems] : []
    }

    return(
      <div styleName='wrapper' ref={el => this.wrapper = el}>
        <CSSTransition
          in={visible}
          timeout={250}
          classNames='dropdown'
          unmountOnExit
        >
          <div styleName='dropdown'>
            <Search {...searchProps}/>
            <ul>
              {items.map(item => {
                if (typeof item !== 'object') {
                  item = {
                    value: item,
                    label: item
                  }
                }
                return <li
                  key={item.value}
                  styleName={
                    (active === item.value ? 'active' : '') +
                    (selected.indexOf(item.value) !== -1 ? ' selected' : '') +
                    (loadingItems.indexOf(item.value) !== -1 ? ' loading' : '')
                  }
                >
                  <button
                    value={item.value}
                    onClick={onSelect}
                    onMouseEnter={this.handleMouseEnter}
                    onMouseLeave={this.handleMouseLeave}
                  >
                    {item.label}
                  </button>
                </li>
              })}
            </ul>
          </div>
        </CSSTransition>
      </div>
    )
  }
}

export default Dropdown
